import { render, staticRenderFns } from "./InventoryProductList.vue?vue&type=template&id=86a06784&"
import script from "./InventoryProductList.vue?vue&type=script&lang=js&"
export * from "./InventoryProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports